document.querySelectorAll('.faq-question').forEach(button => {
    button.addEventListener('click', function() {
      const item = this.closest('.faq-item');
      document.querySelectorAll('.faq-item').forEach(faq => {
        if (faq !== item) {
          faq.classList.remove('active');

          const icon = faq.querySelector('.icon');
          if (icon) icon.textContent = '+';
        }
      });
      item.classList.toggle('active');
      const icon = item.querySelector('.icon');
      icon.textContent = item.classList.contains('active') ? '−' : '+';
    });
});
